import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[appRestrictInput]',
  standalone: true,
})
export class RestrictInputDirective implements OnInit {
  @Input() allowedInput: string;
  private regex: RegExp;

  private specialKeys: Array<string> = ['Backspace', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.regex = new RegExp(this.allowedInput);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.elementRef.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
